import React, { useEffect } from 'react';
import UserForm from '../forms/UserForm';

const UserModal = ({ user, onClose }) => {
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 pt-[max(1rem,env(safe-area-inset-top))] pb-[max(1rem,env(safe-area-inset-bottom))] overflow-y-auto"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="user-modal-title"
    >
      <div
        className="bg-white dark:bg-slate-800 rounded-2xl sm:rounded-3xl p-6 sm:p-8 max-w-4xl w-full shadow-2xl border border-slate-100 dark:border-slate-700 slide-in my-8 max-h-dvh-90 overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center mb-4 sm:mb-6">
          <h2 id="user-modal-title" className="text-2xl sm:text-3xl font-bold gradient-text flex items-center gap-2 sm:gap-3">
            <span className="w-8 h-8 sm:w-10 sm:h-10 bg-gradient-to-br from-primary to-accent rounded-xl flex items-center justify-center shrink-0">
              <i className={`fas ${user ? 'fa-user-edit' : 'fa-user-plus'} text-white text-sm sm:text-base`} aria-hidden="true"></i>
            </span>
            {user ? 'Edit User' : 'Create New User'}
          </h2>
          <button
            onClick={onClose}
            className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-700 hover:bg-slate-200 dark:hover:bg-slate-600 text-slate-600 dark:text-slate-300 hover:text-slate-800 dark:hover:text-white transition-all duration-300 flex items-center justify-center btn-hover-scale shrink-0"
            aria-label="Close"
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>
        </div>

        <UserForm user={user} onSuccess={onClose} onCancel={onClose} />
      </div>
    </div>
  );
};

export default UserModal;
